import { render, staticRenderFns } from "./CollapseDraggable.vue?vue&type=template&id=619de019&"
import script from "./CollapseDraggable.vue?vue&type=script&lang=js&"
export * from "./CollapseDraggable.vue?vue&type=script&lang=js&"
import style0 from "./CollapseDraggable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports